import React from 'react'
import _ from 'lodash'
import { Button } from '@mui/material'
import LaudoVisita from 'entity/LaudoVisita'
import { getColDataCustomForm } from 'entity/dbApiForms'
import { getAllIndicadores } from 'entity/Indicador/all'
import getAllTiposIndicador from 'entity/TipoIndicador/all'

const compareName = (a, b) => {
    if (a.tecnico?.nome < b.tecnico?.nome) {
        return -1
    } else if (a.tecnico?.nome > b.tecnico?.nome) {
        return 1
    } else {
        return 0
    }
}

export const getList = async (dataInicio, dataFim) => {
    const dataInicioSemHifens = dataInicio.replace(/-/g, '')
    const dataFimSemHifens = dataFim.replace(/-/g, '')

    let collection = getColDataCustomForm({ uid: 'sSCy71ONYFEwlGVDK4kK' })
    collection = collection.orderBy("dataStr", "desc");
    collection = collection.where("dataStr", ">=", dataInicioSemHifens)
    collection = collection.where("dataStr", "<=", dataFimSemHifens)

    console.log('getList')
    let qs = await collection.get();

    let lista = [];
    if (!qs.empty) {
        qs.forEach((doc) => {
            lista.push(doc.data());
        });
    }

    return lista
}

export const DebugCSV = () => {
    const currentURL = window.location.href
    const inDebug = currentURL.includes("localhost") && !window.cordova
    if (!inDebug) {
        return ""
    }
    // let lista = getList()

    return (
        <div style={{ position: 'fixed', bottom: 0 }}>
            <Button
                variant='contained'
                color='primary'
                onClick={async () => await estatisticaCSV(/*list*/await getList())}
            >
                Salvar CSV
            </Button>
        </div>
    )
}

export const DebugCSVIndicadores = () => {
    const currentURL = window.location.href
    const inDebug = currentURL.includes("localhost") && !window.cordova
    if (!inDebug) {
        return ""
    }
    // let lista = getList()

    return (
        <div style={{ position: 'fixed', bottom: 0, left: 130 }}>
            <Button
                variant='contained'
                color='primary'
                onClick={exportIndicadores}
            // onClick={async () => await estatisticaCSV(/*list*/await getList())}
            >
                Salvar CSV Indicadores
            </Button>
        </div>
    )
}

export const DebugCSVTipoIndicadores = () => {
    const currentURL = window.location.href
    const inDebug = currentURL.includes("localhost") && !window.cordova
    if (!inDebug) {
        return ""
    }
    // let lista = getList()

    return (
        <div style={{ position: 'fixed', bottom: 0, left: 355 }}>
            <Button
                variant='contained'
                color='primary'
                onClick={async () => await estatisticaCSV(/*list*/await getList())}
            >
                Salvar CSV Tipo Indicadores
            </Button>
        </div>
    )
}

export const estatisticaCSV = (list) => {
    // console.log('list', list)
    list.sort(compareName)
    exportarCSV(list, LaudoVisita.csvColumns)
}

export const exportIndicadores = () => {
    let indicadoresList = getAllIndicadores()
    let tipoIndicadorList = getAllTiposIndicador()
    createCSVIndicadoresContent(indicadoresList, tipoIndicadorList)
}

const createCSVIndicadoresContent = (indicadores, tiposIndicadores) => {
    let strCsv = "abbrev,field,fullName,tipoIndicador\n";
    indicadores.forEach(ind => {
        let tipoIndicador = ''
        tiposIndicadores.forEach(ti => {
            if (ti.indicadores.includes(ind)) {
                tipoIndicador += `${ti.field},`
            }
        })

        strCsv += `${ind.abbrev},"${ind.field}","${ind.fullName}","${tipoIndicador}"\n`
    })

    gerarArquivo(strCsv, `ExportIndicadores.csv`)
}

const exportarCSV = (list, columns) => {

    let conf = columns

    if (list.length) {
        createCSVContent(list, conf)
    } else {
        console.log("Lista vazia p/ criação de CSV")
    }

}

const createCSVContent = (list, conf) => {
    let strCsv = '';
    let separator = ';'
    conf.forEach(c => {
        strCsv += c.labelCol + separator
    })
    strCsv += '\n'

    list.forEach(l => {
        conf.forEach(c => {
            let v = ""
            if (_.isString(c.getValue)) {
                v = _.get(l, c.getValue)
                if (v) {
                    v = '"' + v + '"'
                }
            } else {
                v = c.getValue(l)
            }
            if (!v) {
                v = ''
            }
            strCsv += v + separator
        })
        strCsv += '\n'
    })

    gerarArquivo(strCsv, `ExportarCSVTCH.csv`)
}

const gerarArquivo = (texto, nome) => {

    let fileBlob = new Blob(["\ufeff", texto])
    if (window.cordova) {
        document.addEventListener("deviceready", function () {
            var storageLocation = ""
            console.log('window.cordova', window.cordova)
            storageLocation = window.cordova.file.dataDirectory

            var folderPath = storageLocation
            console.log('folderPath', folderPath)
            console.log('nome', nome)
            window.resolveLocalFileSystemURL(
                folderPath,
                function (dir) {
                    console.log("Access to the directory granted succesfully", dir)
                    dir.getFile(
                        nome,
                        {
                            create: true
                        },
                        function (file) {
                            console.log('file', file)
                            file.createWriter(
                                function (fileWriter) {
                                    fileWriter.write(fileBlob)

                                    fileWriter.onwriteend = function () {
                                        var url = file.toURL()
                                        console.log('url', url)
                                        window.cordova.plugins.fileOpener2.open(folderPath + nome, "text/plain", {
                                            error: function error(err) {
                                                console.error(err)
                                                alert("Unable to download3")
                                            },
                                            success: function success() {
                                                console.log("success with opening the file")
                                            }
                                        })
                                    }

                                    fileWriter.onerror = function (err) {
                                        alert("Unable to download2")
                                        console.error(err)
                                    }
                                },
                                function (err) {
                                    // failed
                                    alert("Unable to download")
                                    console.error('err', err)
                                }
                            )
                        },
                        function (err) {
                            alert("Unable to download")
                            console.error(err)
                        }
                    )
                },
                function (err) {
                    alert("Unable to download")
                    console.error(err)
                }
            )
        })
    } else {

        var element = document.createElement("a")

        // let file = new Blob([texto], { type: "text/plain;charset=utf-8" })
        element.href = URL.createObjectURL(fileBlob)
        element.download = nome
        element.click()
    }
}

export const DebugFiltroConsultaVisita = ({ form, ...props }) => {
    const currentURL = window.location.href
    const inDebug = currentURL.includes("localhost") && !window.cordova
    if (!inDebug) {
        return ""
    }

    return (
        <div>
            <Button
                variant='contained'
                color='primary'
                onClick={async () => {
                    let obj = {
                        dataInicio: "2024-03-24",
                        dataFim: "2024-03-25",
                        fazenda: { nomeFazenda: "Aa" },
                        sequencialIndex: 23722,
                        status: "Em Digitação",
                        tecnico: { nome: "Ivanildo Fernandes - OKDS" },
                        cliente: {
                            "cidade": "Dourados",
                            "uid": "2D4sSMEB0LzMoTFt6tf3",
                            "tempAdd": null,
                            "dataLastChangeISO": "2024-03-06T21:28:24.311Z",
                            "dataLastChange": {
                                "seconds": 1709760504,
                                "nanoseconds": 311000000
                            },
                            "userLastChange": "ZWUmEfSidbU9sSQ6597iEuMzmSd2",
                            "estado": "MS",
                            "status": "ATIVO",
                            "sequencialIndex": 225,
                            "dataLastChangeStr": "06/03/2024 17:28",
                            "telefone": "6712345645",
                            "dataLastChangeServer": {
                                "seconds": 1709760498,
                                "nanoseconds": 929000000
                            },
                            "nome": "Teste de Indicadores",
                            "salvoOffline": false,
                            "params": {
                                "vcc": {
                                    "manual": {
                                        "intervaloMax": "105",
                                        "metrosLinearesAmostra": "50",
                                        "intervaloMin": "95",
                                        "metrosLinearesHectare": "5",
                                        "meta": "95"
                                    },
                                    "mecanizado": {
                                        "intervaloMin": "94",
                                        "metrosLinearesAmostra": "40",
                                        "meta": "94",
                                        "intervaloMax": "104",
                                        "metrosLinearesHectare": "4"
                                    }
                                },
                                "as": {
                                    "items": [
                                        {
                                            "classificacao": "Ótimo",
                                            "intervaloMax": "5",
                                            "sinalIntervaloMin": ">=",
                                            "sinalIntervaloMax": "<=",
                                            "intervaloMin": "0"
                                        },
                                        {
                                            "intervaloMax": "10",
                                            "sinalIntervaloMax": "<=",
                                            "classificacao": "Bom",
                                            "sinalIntervaloMin": ">",
                                            "intervaloMin": "5"
                                        },
                                        {
                                            "sinalIntervaloMax": "<=",
                                            "sinalIntervaloMin": ">",
                                            "intervaloMin": "10",
                                            "intervaloMax": "100",
                                            "classificacao": "Horrível"
                                        }
                                    ],
                                    "mecanizado": {
                                        "meta": "3"
                                    }
                                },
                                "perd": {
                                    "mecanizado": {
                                        "meta": "5"
                                    }
                                },
                                "pcorte": {
                                    "items": [
                                        {
                                            "sinalIntervaloMax": "<=",
                                            "sinalIntervaloMin": ">=",
                                            "intervaloMin": "90",
                                            "intervaloMax": "100",
                                            "classificacao": "Bom"
                                        },
                                        {
                                            "intervaloMin": "0",
                                            "sinalIntervaloMax": "<",
                                            "intervaloMax": "90",
                                            "sinalIntervaloMin": ">=",
                                            "classificacao": "Ruim"
                                        }
                                    ],
                                    "manual": {
                                        "intervaloMinInverno": "2",
                                        "intervaloMaxVerao": "5",
                                        "intervaloMin": "1",
                                        "intervaloMax": "3",
                                        "meta": "90",
                                        "intervaloMaxInverno": "4",
                                        "intervaloMinVerao": "1"
                                    }
                                },
                                "piso": {
                                    "mecanizado": {
                                        "meta": "3"
                                    }
                                },
                                "avl": {
                                    "manual": {
                                        "intervaloMin": "0",
                                        "meta": "100",
                                        "metrosLinearesHectare": "10",
                                        "intervaloMax": "49",
                                        "metrosLinearesAmostra": "1"
                                    }
                                },
                                "arsub": {
                                    "manual": {
                                        "intervaloMin": "2",
                                        "meta": "90",
                                        "intervaloMax": "5"
                                    },
                                    "mecanizado": {
                                        "meta": "90",
                                        "intervaloMax": "5",
                                        "intervaloMin": "2"
                                    }
                                },
                                "tmm": {
                                    "mecanizado": {
                                        "meta": "02:00"
                                    },
                                    "items": []
                                },
                                "TAH": {
                                    "manual": {
                                        "meta": "90"
                                    },
                                    "mecanizado": {
                                        "meta": "90"
                                    }
                                },
                                "uql": {
                                    "manual": {
                                        "meta": "90",
                                        "intervaloMax": "5",
                                        "intervaloMin": "2"
                                    },
                                    "mecanizado": {
                                        "intervaloMax": "5",
                                        "intervaloMin": "2",
                                        "meta": "90"
                                    }
                                },
                                "bio": {
                                    "manual": {
                                        "canasAvaliadas": "10",
                                        "metrosAvaliados": "10",
                                        "metroLinear": "1"
                                    }
                                },
                                "ado": {
                                    "mecanizado": {
                                        "metrosLinearesHectare": "9",
                                        "metrosLinearesAmostra": "4",
                                        "meta": "93",
                                        "intervaloMin": "3",
                                        "intervaloMax": "5"
                                    },
                                    "manual": {
                                        "intervaloMax": "8",
                                        "metrosLinearesAmostra": "2",
                                        "meta": "90",
                                        "metrosLinearesHectare": "10",
                                        "intervaloMin": "2"
                                    }
                                },
                                "lbm": {
                                    "manual": {
                                        "meta": "5"
                                    }
                                },
                                "ipsp": {
                                    "mecanizado": {
                                        "meta": "90"
                                    },
                                    "manual": {
                                        "meta": "90"
                                    }
                                },
                                "perf": {
                                    "manual": {
                                        "metrosAvaliados": "1"
                                    }
                                },
                                "ps": {
                                    "mecanizado": {
                                        "meta": "80",
                                        "intervaloMin": "20",
                                        "intervaloMax": "40"
                                    },
                                    "manual": {
                                        "intervaloMax": "0.45",
                                        "intervaloMin": "0.35",
                                        "meta": "95"
                                    },
                                    "items": [
                                        {
                                            "intervaloMax": "98",
                                            "classificacao": "Bom",
                                            "intervaloMin": "91",
                                            "sinalIntervaloMin": ">=",
                                            "sinalIntervaloMax": "<"
                                        },
                                        {
                                            "sinalIntervaloMax": "<=",
                                            "intervaloMax": "100",
                                            "classificacao": "Ótimo",
                                            "sinalIntervaloMin": ">=",
                                            "intervaloMin": "98"
                                        },
                                        {
                                            "intervaloMax": "90",
                                            "sinalIntervaloMin": ">=",
                                            "intervaloMin": "0",
                                            "classificacao": "Ruim",
                                            "sinalIntervaloMax": "<"
                                        }
                                    ]
                                },
                                "adh": {
                                    "mecanizado": {
                                        "intervaloMin": "88",
                                        "intervaloMax": "98",
                                        "metrosLinearesHectare": "800",
                                        "meta": "98",
                                        "metrosLinearesAmostra": "98"
                                    }
                                },
                                "mudaMecanizada": {
                                    "manual": {
                                        "obs": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
                                        "meta": "80",
                                        "gemasDanificadasParam": "85",
                                        "nosRachados": "97",
                                        "entrenosRachados": "97",
                                        "palmitoAgregado": "97",
                                        "tamToletesPicados": "95",
                                        "entrenosRachadosParam": "97",
                                        "gemasDanificadas": "85",
                                        "tamToletesPicadosParam": "95",
                                        "nosRachadosParam": "97",
                                        "palmitoAgregadoParam": "97"
                                    }
                                },
                                "pdt": {
                                    "manual": {
                                        "intervaloMin": "2",
                                        "meta": "94",
                                        "items": [
                                            {
                                                "classificacao": "Bom",
                                                "intervaloMin": "94",
                                                "sinalIntervaloMax": "<=",
                                                "sinalIntervaloMin": ">=",
                                                "intervaloMax": "100"
                                            }
                                        ],
                                        "intervaloMax": "20"
                                    },
                                    "mecanizado": {
                                        "intervaloMin": "1",
                                        "items": [
                                            {
                                                "classificacao": "Okay",
                                                "intervaloMin": "91",
                                                "sinalIntervaloMin": ">=",
                                                "intervaloMax": "100",
                                                "sinalIntervaloMax": "<="
                                            }
                                        ],
                                        "intervaloMax": "17",
                                        "meta": "91"
                                    },
                                    "items": [
                                        {
                                            "classificacao": "Bom",
                                            "sinalIntervaloMax": "<",
                                            "intervaloMin": "90",
                                            "intervaloMax": "95",
                                            "sinalIntervaloMin": ">="
                                        },
                                        {
                                            "sinalIntervaloMin": ">=",
                                            "intervaloMax": "100",
                                            "sinalIntervaloMax": "<=",
                                            "classificacao": "Ótimo",
                                            "intervaloMin": "95"
                                        },
                                        {
                                            "sinalIntervaloMax": "<",
                                            "intervaloMax": "91",
                                            "classificacao": "Ruim",
                                            "sinalIntervaloMin": ">=",
                                            "intervaloMin": "0"
                                        }
                                    ]
                                },
                                "adc": {
                                    "manual": {
                                        "metrosLinearesAmostra": "8",
                                        "metrosLinearesHectare": "4",
                                        "meta": "92",
                                        "intervaloMax": "14",
                                        "intervaloMin": "2"
                                    },
                                    "mecanizado": {
                                        "metrosLinearesHectare": "1",
                                        "metrosLinearesAmostra": "5",
                                        "meta": "95",
                                        "intervaloMin": "1",
                                        "intervaloMax": "15"
                                    }
                                },
                                "acs": {
                                    "mecanizado": {
                                        "meta": "97"
                                    },
                                    "items": [
                                        {
                                            "intervaloMin": "99",
                                            "sinalIntervaloMin": "<=",
                                            "classificacao": "Ótimo",
                                            "sinalIntervaloMax": ">=",
                                            "intervaloMax": "95"
                                        },
                                        {
                                            "classificacao": "Bom",
                                            "sinalIntervaloMax": ">=",
                                            "intervaloMax": "90",
                                            "intervaloMin": "95",
                                            "sinalIntervaloMin": "<"
                                        },
                                        {
                                            "sinalIntervaloMin": "<",
                                            "intervaloMax": "0",
                                            "sinalIntervaloMax": ">=",
                                            "classificacao": "Ruim",
                                            "intervaloMin": "90"
                                        }
                                    ]
                                },
                                "ibf": {
                                    "mecanizado": {
                                        "meta": "18"
                                    }
                                },
                                "dp": {
                                    "mecanizado": {
                                        "intervaloMin": "2",
                                        "intervaloMax": "12",
                                        "items": [
                                            {
                                                "sinalIntervaloMax": "<=",
                                                "intervaloMin": "2",
                                                "intervaloMax": "12",
                                                "classificacao": "Bom",
                                                "sinalIntervaloMin": ">="
                                            }
                                        ],
                                        "meta": "2"
                                    },
                                    "manual": {
                                        "items": [
                                            {
                                                "intervaloMax": "15",
                                                "sinalIntervaloMax": "<=",
                                                "sinalIntervaloMin": ">=",
                                                "classificacao": "Okay",
                                                "intervaloMin": "5"
                                            }
                                        ],
                                        "intervaloMin": "5",
                                        "meta": "5",
                                        "intervaloMax": "15"
                                    }
                                },
                                "adf": {
                                    "mecanizado": {
                                        "meta": "92",
                                        "metrosLinearesAmostra": "54",
                                        "intervaloMin": "94",
                                        "metrosLinearesHectare": "6",
                                        "intervaloMax": "104"
                                    },
                                    "manual": {
                                        "intervaloMin": "93",
                                        "metrosLinearesHectare": "6.3",
                                        "intervaloMax": "103",
                                        "metrosLinearesAmostra": "53",
                                        "meta": "93"
                                    }
                                },
                                "ttp": {
                                    "mecanizado": {
                                        "meta": "98",
                                        "items": [
                                            {
                                                "sinalIntervaloMin": ">",
                                                "sinalIntervaloMax": "<=",
                                                "intervaloMin2": "8",
                                                "operador": "AND",
                                                "sinalIntervaloMin2": ">",
                                                "intervaloMax": "8",
                                                "intervaloMax2": "48",
                                                "classificacao": "hg",
                                                "intervaloMin": "0",
                                                "sinalIntervaloMax2": "<="
                                            }
                                        ]
                                    },
                                    "items": [
                                        {
                                            "sinalIntervaloMax": "<",
                                            "intervaloMax2": "20",
                                            "operador": "OR",
                                            "sinalIntervaloMax2": "<",
                                            "intervaloMin": "0",
                                            "intervaloMax": "10",
                                            "sinalIntervaloMin2": ">=",
                                            "sinalIntervaloMin": ">=",
                                            "intervaloMin2": "10",
                                            "classificacao": "Ruim"
                                        },
                                        {
                                            "intervaloMin2": "30",
                                            "sinalIntervaloMax2": "<",
                                            "sinalIntervaloMin": ">=",
                                            "intervaloMax2": "70",
                                            "sinalIntervaloMax": "<",
                                            "intervaloMax": "30",
                                            "operador": "OR",
                                            "classificacao": "Bom ",
                                            "sinalIntervaloMin2": ">=",
                                            "intervaloMin": "20"
                                        },
                                        {
                                            "intervaloMax2": "100",
                                            "operador": "OR",
                                            "sinalIntervaloMin2": ">=",
                                            "classificacao": "Ótimo",
                                            "sinalIntervaloMax": "<",
                                            "intervaloMax": "80",
                                            "sinalIntervaloMax2": "<=",
                                            "sinalIntervaloMin": ">=",
                                            "intervaloMin2": "80",
                                            "intervaloMin": "70"
                                        }
                                    ],
                                    "manual": {
                                        "meta": "93",
                                        "items": [
                                            {
                                                "intervaloMin2": "35",
                                                "intervaloMax": "45",
                                                "classificacao": "Bom",
                                                "sinalIntervaloMin2": ">=",
                                                "intervaloMax2": "45",
                                                "intervaloMin": "35",
                                                "sinalIntervaloMax": "<=",
                                                "sinalIntervaloMin": ">=",
                                                "sinalIntervaloMax2": "<=",
                                                "operador": "AND"
                                            },
                                            {
                                                "classificacao": "Regular",
                                                "intervaloMax2": "50",
                                                "sinalIntervaloMin2": ">=",
                                                "sinalIntervaloMax2": "<=",
                                                "sinalIntervaloMin": ">=",
                                                "sinalIntervaloMax": "<=",
                                                "intervaloMin": "30",
                                                "intervaloMax": "34",
                                                "intervaloMin2": "46",
                                                "operador": "AND"
                                            },
                                            {
                                                "intervaloMax2": "0",
                                                "sinalIntervaloMax": "<=",
                                                "sinalIntervaloMin": ">=",
                                                "sinalIntervaloMin2": "<=",
                                                "intervaloMin2": "29",
                                                "intervaloMin": "51",
                                                "sinalIntervaloMax2": ">=",
                                                "intervaloMax": "200",
                                                "operador": "AND",
                                                "classificacao": "Ruim"
                                            }
                                        ]
                                    }
                                },
                                "ba": {
                                    "items": [
                                        {
                                            "intervaloMin": "0",
                                            "sinalIntervaloMin": ">=",
                                            "sinalIntervaloMax": "<=",
                                            "classificacao": "Bom",
                                            "intervaloMax": "30"
                                        },
                                        {
                                            "intervaloMin": "30",
                                            "classificacao": "Ruim",
                                            "sinalIntervaloMin": ">",
                                            "sinalIntervaloMax": "<=",
                                            "intervaloMax": "100"
                                        }
                                    ],
                                    "manual": {
                                        "meta": "30",
                                        "intervaloMax": "",
                                        "intervaloMin": "",
                                        "indiceMariposa": "10",
                                        "indiceMariposas": "10"
                                    }
                                },
                                "altc": {
                                    "mecanizado": {
                                        "intervaloMaxVerao": "0.2",
                                        "intervaloMaxInverno": "0.2",
                                        "intervaloMinVerao": "0.02",
                                        "meta": "92",
                                        "intervaloMinInverno": "0.02"
                                    },
                                    "items": [
                                        {
                                            "classificacao": "Ruim",
                                            "sinalIntervaloMax": "<",
                                            "intervaloMin": "0",
                                            "intervaloMax": "90",
                                            "sinalIntervaloMin": ">="
                                        },
                                        {
                                            "sinalIntervaloMin": ">=",
                                            "intervaloMin": "90",
                                            "intervaloMax": "95",
                                            "classificacao": "Regular",
                                            "sinalIntervaloMax": "<"
                                        },
                                        {
                                            "classificacao": "Ótimo",
                                            "intervaloMin": "95",
                                            "intervaloMax": "100",
                                            "sinalIntervaloMax": "<=",
                                            "sinalIntervaloMin": ">="
                                        }
                                    ],
                                    "manual": {
                                        "intervaloMinInverno": "0.01",
                                        "intervaloMaxVerao": "0.1",
                                        "meta": "91",
                                        "intervaloMaxInverno": "0.1",
                                        "intervaloMinVerao": "0.01"
                                    }
                                },
                                "ngv": {
                                    "metroPontoAvaliado": "4",
                                    "intervaloMin": "14",
                                    "manual": {
                                        "intervaloMax": "15",
                                        "intervaloMin": "5",
                                        "metroPontoAvaliado": "5",
                                        "meta": "95"
                                    },
                                    "meta": "94",
                                    "items": [
                                        {
                                            "sinalIntervaloMin": ">=",
                                            "intervaloMax": "12",
                                            "sinalIntervaloMax": "<",
                                            "classificacao": "Abaixo",
                                            "intervaloMin": "0"
                                        },
                                        {
                                            "sinalIntervaloMin": ">=",
                                            "sinalIntervaloMax": "<=",
                                            "intervaloMin": "12",
                                            "classificacao": "Boa",
                                            "intervaloMax": "20"
                                        },
                                        {
                                            "intervaloMin": "20",
                                            "intervaloMax": "26",
                                            "sinalIntervaloMax": "<",
                                            "sinalIntervaloMin": ">",
                                            "classificacao": "Acima"
                                        }
                                    ],
                                    "intervaloMax": "24",
                                    "mecanizado": {
                                        "meta": "92",
                                        "intervaloMin": "12",
                                        "intervaloMax": "21",
                                        "metroPontoAvaliado": "2"
                                    }
                                },
                                "cm": {
                                    "manual": {
                                        "metrosAvaliados": "1",
                                        "meta": "1000",
                                        "metrosLineares": "1000"
                                    }
                                },
                                "afc": {
                                    "manual": {
                                        "metrosLinearesHectare": "10",
                                        "intervaloMin": "2",
                                        "intervaloMax": "6",
                                        "metrosLinearesAmostra": "1",
                                        "meta": "90"
                                    },
                                    "mecanizado": {
                                        "meta": "90",
                                        "metrosLinearesHectare": "10",
                                        "intervaloMax": "6",
                                        "intervaloMin": "2",
                                        "metrosLinearesAmostra": "1"
                                    }
                                },
                                "ttc": {
                                    "mecanizado": {
                                        "meta": "01:00"
                                    },
                                    "manual": {
                                        "meta": "01:00"
                                    }
                                },
                                "ees": {
                                    "manual": {
                                        "meta": "95",
                                        "intervaloMax": "1.55",
                                        "intervaloMin": "1.45"
                                    },
                                    "items": [
                                        {
                                            "sinalIntervaloMax": "<=",
                                            "sinalIntervaloMin": ">=",
                                            "classificacao": "Ótimo",
                                            "intervaloMin": "99",
                                            "intervaloMax": "100"
                                        },
                                        {
                                            "sinalIntervaloMin": ">=",
                                            "sinalIntervaloMax": "<",
                                            "classificacao": "Bom",
                                            "intervaloMin": "95",
                                            "intervaloMax": "98"
                                        },
                                        {
                                            "sinalIntervaloMin": ">=",
                                            "intervaloMax": "95",
                                            "classificacao": "Regular",
                                            "intervaloMin": "90",
                                            "sinalIntervaloMax": "<"
                                        },
                                        {
                                            "sinalIntervaloMin": ">=",
                                            "intervaloMin": "0",
                                            "classificacao": "Ruim",
                                            "intervaloMax": "90",
                                            "sinalIntervaloMax": "<"
                                        }
                                    ],
                                    "mecanizado": {
                                        "meta": "90",
                                        "intervaloMax": "1.50",
                                        "intervaloMin": "1.40"
                                    }
                                },
                                "lc": {
                                    "items": [
                                        {
                                            "classificacao": "Ótimo",
                                            "intervaloMax": "100",
                                            "sinalIntervaloMin": ">=",
                                            "sinalIntervaloMax": "<=",
                                            "intervaloMin": "95"
                                        },
                                        {
                                            "classificacao": "Bom",
                                            "intervaloMax": "90",
                                            "intervaloMin": "95",
                                            "sinalIntervaloMin": "<",
                                            "sinalIntervaloMax": ">="
                                        },
                                        {
                                            "classificacao": "Ruim",
                                            "intervaloMax": "0",
                                            "sinalIntervaloMin": "<",
                                            "sinalIntervaloMax": ">=",
                                            "intervaloMin": "90"
                                        }
                                    ],
                                    "manual": {
                                        "metroPontoAvaliado": "1",
                                        "intervaloMin": "0",
                                        "metaMaxAdultas": "4",
                                        "intervaloMax": "7",
                                        "meta": "1"
                                    }
                                },
                                "tmt": {
                                    "mecanizado": {
                                        "meta": "01:40"
                                    },
                                    "items": [
                                        {
                                            "intervaloMin": "00:00",
                                            "sinalIntervaloMin": ">=",
                                            "intervaloMax": "01:40",
                                            "classificacao": "Ótimo",
                                            "sinalIntervaloMax": "<="
                                        },
                                        {
                                            "intervaloMin": "01:40",
                                            "classificacao": "Bom",
                                            "intervaloMax": "01:50",
                                            "sinalIntervaloMax": "<=",
                                            "sinalIntervaloMin": ">"
                                        },
                                        {
                                            "classificacao": "Regular",
                                            "intervaloMin": "01:50",
                                            "sinalIntervaloMax": "<=",
                                            "sinalIntervaloMin": ">",
                                            "intervaloMax": "02:00"
                                        },
                                        {
                                            "intervaloMin": "02:00",
                                            "classificacao": "Ruim",
                                            "sinalIntervaloMin": ">"
                                        }
                                    ]
                                },
                                "falhas": {
                                    "manual": {
                                        "metrosPorPonto": "1",
                                        "meta": "1"
                                    }
                                },
                                "adn": {
                                    "manual": {
                                        "meta": "100",
                                        "metrosLinearesAmostra": "1",
                                        "intervaloMax": "49",
                                        "metrosLinearesHectare": "10",
                                        "intervaloMin": "0"
                                    },
                                    "mecanizado": {
                                        "metrosLinearesHectare": "10",
                                        "meta": "100",
                                        "intervaloMin": "0",
                                        "metrosLinearesAmostra": "1",
                                        "intervaloMax": "49"
                                    }
                                },
                                "pc": {
                                    "intervaloMax": "7",
                                    "manual": {
                                        "meta": "90",
                                        "intervaloMax": "7",
                                        "intervaloMin": "2"
                                    },
                                    "intervaloMin": "2",
                                    "mecanizado": {
                                        "intervaloMax": "6",
                                        "intervaloMin": "1",
                                        "meta": "91"
                                    }
                                }
                            },
                            "anexos": {
                                "realName": "dummy.pdf",
                                "storagePath": "cliente/anexos/metodologiasAvaliacao/ViEv1LYy65Nedh0vAYbb-dummy.pdf",
                                "dateUpdate": "2023-09-29T15:23:48.898Z",
                                "size": 13264,
                                "dateCreate": "2023-09-29T15:23:48.898Z",
                                "filename": "ViEv1LYy65Nedh0vAYbb-dummy.pdf",
                                "userUid": "lZLannLpO5N5dEPYQe0aKo5fCIj2",
                                "type": "application/pdf",
                                "downloadURL": "https://firebasestorage.googleapis.com/v0/b/tchqualidade.appspot.com/o/cliente%2Fanexos%2FmetodologiasAvaliacao%2FViEv1LYy65Nedh0vAYbb-dummy.pdf?alt=media&token=c5b2d305-0241-41b4-b9e6-a667539b1746",
                                "userName": "Carlos Antonio - OKDS"
                            },
                            "perfisAutorizado": {
                                "lZLannLpO5N5dEPYQe0aKo5fCIj2": true,
                                "Uy5WfGYlwAVUKLfA6gZAuEImPon1": true
                            }
                        }
                    }

                    form.change('dataFim', obj.dataFim)
                    form.change('dataInicio', obj.dataInicio)
                    // form.change('fazenda', obj.fazenda)
                    // form.change('sequencialIndex', obj.sequencialIndex)
                    // form.change('status', obj.status)
                    // form.change('tecnico', obj.tecnico)
                    form.change('cliente', obj.cliente)
                }}
            >
                Definir Filtros Dev
            </Button>
        </div>
    )
}

export const DebugFiltroConsole = ({ values }) => {
    const currentURL = window.location.href
    const inDebug = currentURL.includes("localhost") && !window.cordova
    if (!inDebug) {
        return ""
    }

    return (
        <div>
            <Button
                variant='contained'
                color='primary'
                onClick={async () => console.log('valores filtro', values)}
            >
                Console Filtro Dev
            </Button>
        </div>
    )
}